import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./EditFieldModal.scss";
import { GreyBorderButton, RedBackgroundButton } from "../../../../../Global/GlobalButton";
import { useDispatch } from "react-redux";
import { updateFieldMinMax } from "../../../../../Redux/Users/action";

const EditFieldModal = ({ field, onSave, onClose }) => {
  const [updatedField, setUpdatedField] = useState(() => {
    const deepCopyField = JSON.parse(JSON.stringify(field));
    deepCopyField.criteria = deepCopyField.criteria || "Min/Max Criteria";
    deepCopyField.fields = deepCopyField.fields || [{ minValue: "", maxValue: "" }];
    return deepCopyField;
  });
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [minMaxValues, setMinMaxValues] = useState({
    minValue: updatedField.fields[0].minValue || "",
    maxValue: updatedField.fields[0].maxValue || ""
  });

  useEffect(() => {
    const deepCopyField = JSON.parse(JSON.stringify(field));
    deepCopyField.criteria = deepCopyField.criteria || "min";
    deepCopyField.fields = deepCopyField.fields || [{ minValue: "", maxValue: "" }];
    setUpdatedField(deepCopyField);

    setMinMaxValues({
      minValue: deepCopyField.fields[0].minValue || "",
      maxValue: deepCopyField.fields[0].maxValue || ""
    });
  }, [field]);

  const handleChange = (e, index, fieldName) => {
    const { value } = e.target;
  
    const updatedFields = updatedField.fields.map((field, idx) => {
      if (idx === index) {
        return { ...field, [fieldName]: value }; // Update the specific field
      }
      return field;
    });
  
    setUpdatedField({
      ...updatedField,
      fields: updatedFields,
    });
  };
  
  
  const handleCriteriaChange = (e) => {
    const value = e.target.value;
    setUpdatedField({
      ...updatedField,
      criteria: value,
      fields: value === "custom" ? [{ minValue: "", maxValue: "" }] : updatedField.fields,
    });
  };

  const handleMinMaxChange = (e, valueName) => {
    const { value } = e.target;
    setMinMaxValues({
      ...minMaxValues,
      [valueName]: value,
    });

    setUpdatedField({
      ...updatedField,
      fields: updatedField.fields.map((field) => ({
        ...field,
        [valueName]: value,
      })),
    });
  };


  const addField = () => {
    setUpdatedField({
      ...updatedField,
      fields: [
        ...updatedField.fields,
        { minValue: "", maxValue: "", id: Date.now() },
      ],
    });
  };

  const removeField = (id) => {
    const updatedFields = updatedField.fields.filter((field) => field.id !== id);
    setUpdatedField({
      ...updatedField,
      fields: updatedFields,
    });
  };

  const handleSave = () => {
    if (updatedField.criteria === "custom") {
      const hasEmptyFields = updatedField.fields.some(
        (field) => !field.minValue || !field.maxValue
      );
  
      if (hasEmptyFields) {
        setError("Both Min and Max values are required for each custom field.");
        return;
      }
    } else if (updatedField.criteria === "Min/Max Criteria") {
      const firstField = updatedField.fields[0];
      if (!firstField.minValue || !firstField.maxValue) {
        setError("Both Min and Max values are required for Min/Max Criteria.");
        return;
      }
    }
  
    const updatedData = {
      ...updatedField,
      fields: updatedField.fields.map(field => ({
        ...field,
        minValue: field.minValue || "", 
        maxValue: field.maxValue || "", 
      })),
    };
  
  
    setError(""); 
  
    onSave(updatedData); 
    onClose(); 
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal show={true} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Form Field Editor</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="registration_edit">
          <form className="registration_edit_form" onSubmit={(e) => e.preventDefault()}>
            <div className="registration_edit_row">
              <label>Criteria</label>
              <select
                name="criteria"
                value={updatedField.criteria}
                onChange={handleCriteriaChange}
                className="form-control"
              >
                <option value="Min/Max Criteria">Min/Max Criteria</option>
                <option value="custom">Custom</option>
              </select>
            </div>

            {(updatedField.criteria === "min" || updatedField.criteria === "max" || updatedField.criteria === "Min/Max Criteria") && (
              <>
                <div className="registration_edit_row">
                  <label>Min Value</label>
                  <input
                    type="number"
                    name="minValue"
                    value={minMaxValues.minValue}
                    onChange={(e) => handleMinMaxChange(e, 'minValue')}
                    className="form-control"
                  />
                </div>

                <div className="registration_edit_row">
                  <label>Max Value</label>
                  <input
                    type="number"
                    name="maxValue"
                    value={minMaxValues.maxValue}
                    onChange={(e) => handleMinMaxChange(e, 'maxValue')}
                    className="form-control"
                  />
                </div>
              </>
            )}

            {updatedField.criteria === "custom" && (
              <>
          {updatedField.fields.map((field, index) => (
  <div key={field.id} className="registration_edit_row">
    <div className="d-flex">
      <input
        type="text"
        name="minValue"
        placeholder="Min Label"
        value={field.minValue}
        onChange={(e) => handleChange(e, index,'minValue')}
        className="form-control"
      />
      <input
        type="text"
        name="maxValue"
        placeholder="Max Label"
        value={field.maxValue}
        onChange={(e) => handleChange(e, index,'maxValue')}
        className="form-control"
      />
      <button
        type="button"
        className="btn btn-danger ml-2"
        onClick={() => removeField(field.id)}
      >
        Remove
      </button>
    </div>
  </div>
))}


                <div className="registration_edit_row">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={addField}
                  >
                    Add Field
                  </button>
                </div>
              </>
            )}

            {error && <div className="error-message text-danger">{error}</div>}

            <div className="registration_edit_btn">
              <GreyBorderButton variant="secondary" onClick={handleClose}>
                Cancel
              </GreyBorderButton>
              <RedBackgroundButton
                variant="primary"
                onClick={handleSave}
                type="button"
              >
                Save
              </RedBackgroundButton>
            </div>
          </form>
        </div>
      </Modal.Body>
    </Modal>
  );  
};

export default EditFieldModal;
